import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
const IntentBehaviorContext = /*#__PURE__*/ React.createContext({
    getDisabled: ()=>false,
    getTooltip: ()=>null
});
export const useIntentBehavior = ()=>useContext(IntentBehaviorContext);
export const IntentBehaviorProvider = (param)=>{
    let { children, value } = param;
    return /*#__PURE__*/ _jsx(IntentBehaviorContext.Provider, {
        value: value,
        children: children
    });
};
